// SPDX-License-Identifier: AGPL-3.0-or-later

export type TableStandUp = 'stand' | 'confirm';

// E at a table seat in the 3D room. The server's leave forfeits a running game for a player at it
// (TableGameService.leave), so that asks first; a lobby (getting up leaves it, useRoomWalk), an ended game, a table I
// do not play at and a watch seat lose nothing, and E stands up at once.
export function tableStandUp(
	role: 'player' | 'watch',
	summary: {status: string; players: ReadonlyArray<{user_id: string}>} | null,
	userId: string | null,
): TableStandUp {
	if (role !== 'player' || summary?.status !== 'playing') return 'stand';
	return summary.players.some((player) => player.user_id === userId) ? 'confirm' : 'stand';
}
